import { render, staticRenderFns } from "./AddRule.vue?vue&type=template&id=18fc6186&"
import script from "./AddRule.vue?vue&type=script&lang=js&"
export * from "./AddRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports